import type { InventoryItem } from '@/modules/inventory/types';

const NON_RESERVABLE_STATUSES = new Set([
  'sold',
  'inactive',
  'maintenance',
  'repair',
  'inspection',
]);

export function isRentalItem(item: InventoryItem): boolean {
  return item.mode === 'rental';
}

/** Ítem alquilable y con estado operativo que permite nueva reserva. */
export function isItemEligibleForReservation(item: InventoryItem): boolean {
  if (!isRentalItem(item)) return false;
  return !NON_RESERVABLE_STATUSES.has(item.status);
}

export function itemIneligibilityReason(item: InventoryItem): string | null {
  if (!isRentalItem(item)) return 'Solo artículos en modo alquiler.';
  if (item.status === 'sold') return 'Artículo vendido.';
  if (item.status === 'inactive') return 'Artículo inactivo.';
  if (item.status === 'maintenance') return 'En mantenimiento.';
  if (item.status === 'repair') return 'En reparación.';
  if (item.status === 'inspection') return 'En inspección.';
  if (item.status === 'reserved') return 'Estado operativo: reservado.';
  if (item.status === 'in_use') return 'Estado operativo: en uso.';
  if (item.status !== 'available') return 'No disponible para reservar.';
  return null;
}
